<script>
  import { _, locale } from 'svelte-intl';
  import { onMount } from "svelte";

  export let purchase; // Purchase

  let availableUntil;

  $: accessExpired = purchase && purchase.expiresAt && (purchase.expiresAt * 1000 < Date.now());

  onMount(() => {
    const { moment } = window;
    if (moment && purchase && purchase.expiresAt && !accessExpired) {
      moment.locale($locale);
      availableUntil = purchase && moment && moment(purchase.expiresAt * 1000).format('DD MMMM');
    }
  });
</script>

<style lang="stylus">
  .available-until
    font-size 14px
    color $violet
    opacity 0.8
    margin-top 10px
</style>

<div class="available-until">
  {#if availableUntil}
    {$_('book_available_until', { date: availableUntil })}
  {/if}

  {#if accessExpired}
    {@html $_('book_access_expired')}
  {/if}

  {#if purchase && !purchase.expiresAt}
    {$_('book_available_indefinitely')}
  {/if}
</div>
